import Rest from '@/services/Rest';

/**
 * @typedef {SubAccountService}
 */
export default class SubAccountService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/user-subaccounts'
}
